export enum OptionTypeEnum {
  NoTextureInGarage = 'NoTextureInGarage',
  SpecialPayment = 'SpecialPayment',
  PreRock = 'PreRock',
}
